export const LINE_WIDTH = 2;
export const LINE_HEIGHT = 2;
export const PIN_SIZE = 18;
export const TIMELINE_STATUS = Object.freeze({
    CURRENT: 'current',
    DEFAULT: 'none',
    DONE: 'done',
    ERROR: 'error',
    PENDING: 'pending',
});
export const TIMELINE_FONT_SIZES = Object.freeze({
    LARGE: 'h2',
    MEDIUM: 'h3',
    SMALL: 'h4',
});
//# sourceMappingURL=constants.js.map